/**
 * TanStack Query 클라이언트 설정
 *
 * 캐시 정책:
 *   - staleTime 1분: 1분 이내 재호출은 캐시 사용
 *   - refetchOnWindowFocus 끔: 윈도우 포커스 변경마다 재호출은 과함
 *   - retry 1: 일시적 네트워크 오류만 1회 재시도
 *
 * 사내 시스템이라 트래픽 작고 데이터 변동도 잦지 않으므로 보수적 기본값.
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60,
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});
